import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLaunchModal } from "./LaunchModal";
import { scrollToId } from "@/lib/scroll";

export default function FinalCTA() {
    const { open } = useLaunchModal();

    return (
        <section id="start" data-testid="final-cta-section" className="relative overflow-hidden py-28 lg:py-40">
            <div className="absolute inset-0 bg-[linear-gradient(180deg,#05070C_0%,#0B1020_48%,#0A1B44_100%)]" />
            <img
                src={`${process.env.PUBLIC_URL}/brand/tavonx-ambient.jpg`}
                alt=""
                loading="lazy"
                aria-hidden="true"
                className="absolute inset-0 h-full w-full object-cover opacity-35"
            />
            <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(5,7,12,0.88)_0%,rgba(5,7,12,0.5)_55%,rgba(10,27,68,0.72)_100%)]" />
            <div className="absolute inset-0 bg-grid bg-grid-fade opacity-60" />

            {/* large X-shaped light element */}
            <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" aria-hidden="true">
                <div className="absolute h-[130%] w-36 -translate-x-1/2 -translate-y-1/2 rotate-[32deg] bg-gradient-to-b from-transparent via-cyber/10 to-transparent blur-3xl" />
                <div className="absolute h-[130%] w-36 -translate-x-1/2 -translate-y-1/2 -rotate-[32deg] bg-gradient-to-b from-transparent via-roy/15 to-transparent blur-3xl" />
            </div>

            {/* official TAVONX mark watermark */}
            <img
                src={`${process.env.PUBLIC_URL}/brand/tavonx-x@3x.png`}
                alt=""
                loading="lazy"
                aria-hidden="true"
                className="pointer-events-none absolute -bottom-16 right-[3%] h-72 w-auto opacity-[0.08] lg:h-[400px]"
            />

            <div className="relative z-10 mx-auto max-w-3xl px-5 text-center sm:px-8">
                <Reveal>
                    <h2 className="font-grotesk text-3xl font-bold uppercase leading-[1.06] tracking-tight text-white sm:text-4xl lg:text-5xl">
                        The next market is
                        <br />
                        <span className="text-grad-blue">already moving.</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="mt-6 text-base leading-relaxed text-slate-400 sm:text-lg">
                        Step into the TAVONX ecosystem.
                    </p>
                </Reveal>
                <Reveal delay={0.2}>
                    <div className="mt-11 flex flex-col items-center justify-center gap-3.5 sm:flex-row">
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                open("trading");
                            }}
                            data-testid="final-cta-start-trading"
                            className="group inline-flex items-center gap-2 rounded bg-gradient-to-r from-electric to-cyber px-9 py-4 font-grotesk text-sm font-semibold uppercase tracking-[0.18em] text-void transition-all duration-200 hover:shadow-[0_0_40px_rgba(0,209,255,0.4)] hover:brightness-110"
                        >
                            Start Trading
                            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                        </a>
                        <a
                            href="#ecosystem"
                            onClick={scrollToId("ecosystem")}
                            data-testid="final-cta-explore-tavonx"
                            className="inline-flex items-center gap-2 rounded border border-white/20 px-9 py-4 font-grotesk text-sm font-semibold uppercase tracking-[0.18em] text-white transition-all duration-300 hover:border-cyber/60 hover:text-cyber"
                        >
                            Explore TAVONX
                            <ArrowUpRight className="h-4 w-4" />
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
